import { Component } from '@angular/core';

import { MechanicsService } from "../services/mechanics.service"
import { UserService } from "../services/user.service"
import { UtilsService } from "../services/utils.service"

@Component({
    selector: 'modal-contact-companies',
    templateUrl: './modal-contact-companies.component.html',
    styleUrls: ['./modal-contact-companies.component.styl'],
    standalone: false
})
export class modalContactCompanyComponent {

	constructor(public ms: MechanicsService,
		public utils: UtilsService,
		public us: UserService) { }


}
